import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../../components/shapes/Line'
import AccordionContent from '../../../../components/structure/accordion/AccordionContent'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import RelatedReplies from './RelatedReplies'
import Reply from './Reply'
import Separator from '../../../../components/helpers/Separator'

const Replies = ({ mainReply, disabled }) => {
  return (
    <AccordionContent separatorWeight={3}>
      <FlexGrid>
        <FlexCol width="1.8rem" />
        <FlexCol flex={1}>
          <HorizontalLine thin lineColor={COLORS.light3} />
          <Separator weight={2} />
          <Reply item={mainReply} disabled={disabled} />
          <Separator weight={2} />
          <RelatedReplies reply={mainReply} />
          <Separator weight={4} />
        </FlexCol>
      </FlexGrid>
    </AccordionContent>
  )
}

export default Replies
